import { render, staticRenderFns } from "./DBNavlists.vue?vue&type=template&id=d7af754a&"
import script from "./DBNavlists.vue?vue&type=script&lang=js&"
export * from "./DBNavlists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports